var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { LocalStorageKeys } from '@/types';
import { getAuthItem, getAuthSessionId } from '@/plugins/auth-storage';
import { ensureFirebaseAuthSession, synchronizeFirebaseAuth } from '@/plugins/firebase-auth-session';
import { deferLoginNavigation, setLoginFirebaseRequest } from '@/plugins/login-navigation';
import { saveNavigationFailure } from '@/utils/session-navigation';
export default (function (context) { return __awaiter(void 0, void 0, Promise, function () {
    var app, route, params, redirect, requiresSession, sessionId, isCurrent, showError, signIn, handleFailure, companyId, ready, error_1, target;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                app = context.app, route = context.route, params = context.params, redirect = context.redirect;
                // callbackは自身のログイン試行にFirebaseの本人確認を束縛する
                if (['/sessions/callback', '/sessions/callback-with-branu-user'].includes(route.path))
                    return [2 /*return*/];
                requiresSession = /^\/(companies|initial-settings)(\/|$)/.test(route.path);
                sessionId = getAuthSessionId();
                isCurrent = function () { return sessionId === getAuthSessionId() && route === context.route; };
                showError = function (statusCode) {
                    if (statusCode === void 0) { statusCode = 503; }
                    return context.error({
                        statusCode: statusCode,
                        message: '一時的に通信できません。時間をおいて再度お試しください'
                    });
                };
                signIn = function () {
                    saveNavigationFailure('initialization-failed', route.fullPath);
                    redirect("/sign_in?redirect_url=" + encodeURIComponent(route.fullPath));
                };
                handleFailure = function (error) { return __awaiter(void 0, void 0, Promise, function () {
                    var currentSessionId, ownsFailure, signOutError_1, status;
                    var _a, _b;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                currentSessionId = getAuthSessionId();
                                if (route !== context.route || (currentSessionId && currentSessionId !== sessionId))
                                    return [2 /*return*/];
                                ownsFailure = function () { return currentSessionId === getAuthSessionId() && route === context.route; };
                                _c.label = 1;
                            case 1:
                                _c.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, synchronizeFirebaseAuth(app.$fire.auth, '', currentSessionId, ownsFailure)];
                            case 2:
                                _c.sent();
                                return [3 /*break*/, 4];
                            case 3:
                                signOutError_1 = _c.sent();
                                if (ownsFailure())
                                    showError();
                                return [2 /*return*/];
                            case 4:
                                if (!ownsFailure())
                                    return [2 /*return*/];
                                status = (_b = (_a = error) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.status;
                                if (requiresSession && (!currentSessionId || (status && [401, 403, 404].includes(status)))) {
                                    saveNavigationFailure('initialization-failed', route.fullPath);
                                    return [2 /*return*/, "/sign_in?redirect_url=" + encodeURIComponent(route.fullPath)];
                                }
                                showError(status || 503);
                                return [2 /*return*/];
                        }
                    });
                }); };
                _b.label = 1;
            case 1:
                _b.trys.push([1, 6, , 8]);
                if (!!sessionId) return [3 /*break*/, 3];
                return [4 /*yield*/, synchronizeFirebaseAuth(app.$fire.auth, '', sessionId, isCurrent)];
            case 2:
                _b.sent();
                if (requiresSession && isCurrent())
                    signIn();
                return [2 /*return*/];
            case 3:
                // 公開画面とログイン・ログアウト導線はWork APIの復旧を待たず表示する
                if (!requiresSession)
                    return [2 /*return*/];
                companyId = params.company_id || ((_a = context.store) === null || _a === void 0 ? void 0 : _a.getters['initial-setting/company'].id) ||
                    getAuthItem(LocalStorageKeys.CompanyId) ||
                    '';
                ready = ensureFirebaseAuthSession(app.$fire.auth, companyId, sessionId, isCurrent);
                setLoginFirebaseRequest(ready);
                if (!!deferLoginNavigation(route, ready, handleFailure)) return [3 /*break*/, 5];
                return [4 /*yield*/, ready];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: return [3 /*break*/, 8];
            case 6:
                error_1 = _b.sent();
                return [4 /*yield*/, handleFailure(error_1)];
            case 7:
                target = _b.sent();
                if (target)
                    redirect(target);
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}); });
